module.exports = __webpack_public_path__ + "img/11.a7f488fa.jpg";